import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api';
import logo from '../assets/logo.png';

const labelStyle = { display: 'block', fontSize: '10px', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(230,190,138,0.6)', fontWeight: '500', marginBottom: '8px' };
const inputStyle = {
  width: '100%', padding: '12px 14px',
  background: 'rgba(255,255,255,0.06)',
  border: '1px solid rgba(230,190,138,0.2)',
  borderRadius: '4px', color: 'var(--white)',
  fontFamily: 'Jost, sans-serif', fontSize: '14px'
};
const buttonStyle = (loading) => ({
  width: '100%', padding: '13px',
  background: 'var(--gold)', color: 'var(--navy)',
  border: 'none', borderRadius: '4px',
  fontFamily: 'Jost, sans-serif', fontSize: '12px',
  fontWeight: '600', letterSpacing: '2px',
  textTransform: 'uppercase', cursor: 'pointer',
  marginTop: '8px', opacity: loading ? 0.7 : 1,
  transition: 'all 0.2s'
});

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, newPassword: password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src={logo} alt="Crossman & Walsh" style={{ width: '120px', height: '120px', borderRadius: '8px', marginBottom: '20px' }} />
          <div style={{ color: 'var(--gold)', letterSpacing: '3px', fontSize: '11px', fontWeight: '500', textTransform: 'uppercase', marginBottom: '4px' }}>
            Crossman & Walsh
          </div>
          <div style={{ color: 'rgba(230,190,138,0.5)', fontFamily: 'Cormorant Garamond, serif', fontStyle: 'italic', fontSize: '16px' }}>
            Staff Portal
          </div>
        </div>

        <div style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(230,190,138,0.2)', borderRadius: '8px', padding: '36px' }}>
          <h2 style={{ color: 'var(--white)', fontFamily: 'Cormorant Garamond, serif', fontSize: '26px', fontWeight: '400', marginBottom: '28px', textAlign: 'center' }}>
            Choose a New Password
          </h2>

          {done ? (
            <>
              <div style={{ background: 'rgba(76,175,80,0.12)', border: '1px solid rgba(76,175,80,0.3)', color: '#9fd6a2', padding: '14px 16px', borderRadius: '4px', fontSize: '13px', lineHeight: 1.6 }}>
                Your password has been reset.
              </div>
              <p style={{ textAlign: 'center', marginTop: '24px', marginBottom: 0 }}>
                <Link to="/login" style={{ color: 'var(--gold)', fontSize: '13px', letterSpacing: '1px', textDecoration: 'none', fontWeight: 600 }}>
                  Sign in now →
                </Link>
              </p>
            </>
          ) : !token ? (
            <div style={{ background: 'rgba(155,58,58,0.15)', border: '1px solid rgba(155,58,58,0.3)', color: '#e08080', padding: '12px 16px', borderRadius: '4px', fontSize: '13px', lineHeight: 1.6 }}>
              This reset link is incomplete. Please use the link from your email, or <Link to="/forgot-password" style={{ color: '#e08080' }}>request a new one</Link>.
            </div>
          ) : (
            <>
              {error && (
                <div style={{ background: 'rgba(155,58,58,0.15)', border: '1px solid rgba(155,58,58,0.3)', color: '#e08080', padding: '12px 16px', borderRadius: '4px', fontSize: '13px', marginBottom: '20px' }}>
                  {error}
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label style={labelStyle}>New Password</label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={8} style={inputStyle} />
                </div>
                <div className="form-group">
                  <label style={labelStyle}>Confirm New Password</label>
                  <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={8} style={inputStyle} />
                </div>
                <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: '12px', marginBottom: '16px' }}>At least 8 characters.</p>
                <button type="submit" disabled={loading} style={buttonStyle(loading)}>
                  {loading ? 'Saving...' : 'Reset Password'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
